/**
 * StatCard - a statistics card for the company dashboard
 *
 * Displays a title, large value, optional subtitle, and optional icon.
 */

import React from 'react';
import styled from 'styled-components';

/* ------------------------------------------------------------------ */
/*  Styled components                                                  */
/* ------------------------------------------------------------------ */

const Card = styled.div`
  background: ${(props) => props.theme.colors.bgTertiary};
  border: 1px solid ${(props) => props.theme.colors.border};
  border-radius: ${(props) => props.theme.borderRadius.md};
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const TopRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Title = styled.span`
  font-size: 0.82rem;
  font-weight: 500;
  color: ${(props) => props.theme.colors.textSecondary};
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const IconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: ${(props) => props.theme.borderRadius.sm};
  background: ${(props) => props.theme.colors.primaryGlow};
  color: ${(props) => props.theme.colors.primary};
  flex-shrink: 0;
`;

const ValueText = styled.div`
  font-size: 2rem;
  font-weight: 800;
  background: ${(props) => props.theme.colors.gradient};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  line-height: 1.1;
  font-family: ${(props) => props.theme.fonts.main};
`;

const Subtitle = styled.span`
  font-size: 0.78rem;
  color: ${(props) => props.theme.colors.textMuted};
`;

/* ------------------------------------------------------------------ */
/*  Component                                                          */
/* ------------------------------------------------------------------ */

function StatCard({ title, value, subtitle, icon }) {
  return (
    <Card>
      <TopRow>
        <Title>{title}</Title>
        {icon && <IconWrapper>{icon}</IconWrapper>}
      </TopRow>
      <ValueText>{value}</ValueText>
      {subtitle && <Subtitle>{subtitle}</Subtitle>}
    </Card>
  );
}

export default StatCard;
